import React from "react";
import { ChevronRight } from "lucide-react";

import { slugCategoria } from "../formato";
import LinhaProdutoOferta from "../LinhaProdutoOferta";
import ItemRecolhido from "./ItemRecolhido";
import { algumParticipa, todosParticipam } from "./ordem";
import PizzaOferta from "./PizzaOferta";

// Uma categoria da aba Produtos. Fechada, mostra só o cabeçalho; aberta, os
// produtos na campanha ficam em linha cheia e os de fora, em blocos pequenos.
export default function CategoriaOferta({ categoria, lista, config, aberta, onAlternar, onMarcarTudo, onMudarProduto, onMudarPizza, onMarcar }) {
  const padrao = config.desconto_max_padrao_pct;
  const n = lista.filter((p) => algumParticipa(p, config)).length;
  const tudo = lista.every((p) => todosParticipam(p, config));

  return (
    <section id={`cat-oferta-${slugCategoria(categoria)}`} data-e2e="categoria-oferta" data-aberta={aberta ? "1" : "0"}
      className={`rounded-xl border scroll-mt-28 ${n > 0 ? "bg-card" : "bg-card/50"}`}>
      <div className={`flex items-center gap-2 px-3 py-2.5 ${aberta ? "border-b" : ""}`}>
        <button type="button" onClick={onAlternar} className="flex flex-1 items-center gap-2 min-w-0 text-left" aria-expanded={aberta}>
          <ChevronRight className={`w-4 h-4 text-muted-foreground transition-transform ${aberta ? "rotate-90" : ""}`} />
          <h4 className="text-xs font-bold uppercase tracking-wide truncate">{categoria}</h4>
          <span className={`text-[11px] font-semibold tabular-nums px-2 py-0.5 rounded-full ${n > 0 ? "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400" : "bg-muted text-muted-foreground"}`}>
            {n}/{lista.length}
          </span>
          {!aberta && <span className="text-[11px] text-muted-foreground truncate hidden sm:inline">{n === 0 ? "fora da campanha" : "na campanha"}</span>}
        </button>
        <button type="button" onClick={() => onMarcarTudo(!tudo)} className="text-xs font-semibold text-primary hover:underline shrink-0">
          {tudo ? "Desmarcar categoria" : "Marcar categoria"}
        </button>
      </div>
      {aberta && (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-2 p-2.5">
          {lista.map((p) => {
            if (!algumParticipa(p, config)) {
              return <ItemRecolhido key={p.id} nome={p.name} foto={p.photo_url} onMarcar={() => onMarcar(p, true)} />;
            }
            if (p.tamanhos) {
              return (
                <PizzaOferta key={p.id} produto={p} config={config} padraoPct={padrao}
                  onMudarTamanho={(tam, r) => onMudarPizza(p.id, tam, r)} onTirar={() => onMarcar(p, false)} />
              );
            }
            return (
              <div key={p.id} className="col-span-full rounded-lg border bg-card px-3">
                <LinhaProdutoOferta nome={p.name} foto={p.photo_url} detalhe={p.preco_combo ? "individual" : ""} preco={p.preco} custo={p.custo}
                  regra={config.produtos?.[p.id]} padraoPct={padrao} onMudar={(r) => onMudarProduto(p.id, r)} />
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
}
